"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../../gen-src/Localize");
var GraphQLErrorFunctions_1 = require("../error/functions/GraphQLErrorFunctions");
function reportConnectToGraphQLErrors(errors) {
    return (errors.map(function (error, i) {
        var errorCode = GraphQLErrorFunctions_1.getGraphQLErrorCode(error);
        var severity = errorCode == null || GraphQLErrorFunctions_1.isFatalError(errorCode) ? widgets_1.ToastType.Error : widgets_1.ToastType.Warning;
        return errorToast(GraphQLErrorFunctions_1.getToastMessageForErrorCode(errorCode), i, severity);
    }));
}
exports.reportConnectToGraphQLErrors = reportConnectToGraphQLErrors;
function reportConnectToWebClientErrors(errors) {
    if (errors.length > 0) {
        return (errors.map(function (error, i) {
            return errorToast(getConnectToErrorMessage(error), i, widgets_1.ToastType.Error);
        }));
    }
    return (errorToast(Localize_1.Messages.ErrorWithoutErrorCode(), 0, widgets_1.ToastType.Error));
}
exports.reportConnectToWebClientErrors = reportConnectToWebClientErrors;
exports.genericGraphQLErrorCode = {
    message: '',
    extensions: {
        code: 'INTERNAL_SERVER_ERROR'
    }
};
function errorToast(message, errorNumber, severity) {
    return (React.createElement(ConnectToErrorToast, { key: "error_" + errorNumber, errorNumber: errorNumber, message: message, toastType: severity }));
}
function getConnectToErrorMessage(errorCode) {
    switch (errorCode) {
        case 'SESSION_EXPIRED':
            return Localize_1.Messages.ErrorSessionTimeout();
        case 'INTERNAL_SERVER_ERROR':
            return Localize_1.Messages.ErrorInternalServerError();
        case 'UNDEFINED':
            return Localize_1.Messages.ErrorWithoutErrorCode();
        default:
            return Localize_1.Messages.ErrorWithoutErrorCode();
    }
}
exports.getConnectToErrorMessage = getConnectToErrorMessage;
// TODO: borrowed from VPC's Toaster.ts, it might be better to pass the callback for the toaster into dc3
var FIRST_TOAST_TOP_MARGIN = 15; // TODO: stolen from Toaster.ts in VPC
var OFFSET_BETWEEN_TOASTS = 45; // TODO: stolen from Toaster.ts in VPC
var ConnectToErrorToast = /** @class */ (function (_super) {
    __extends(ConnectToErrorToast, _super);
    function ConnectToErrorToast(props) {
        var _this = _super.call(this, props) || this;
        _this.onCloseRequest = function () {
            _this.setState({ showToast: false });
        };
        _this.state = { showToast: true };
        return _this;
    }
    ConnectToErrorToast.prototype.render = function () {
        return this.state.showToast
            ? (React.createElement(widgets_1.ToastWidget, { message: this.props.message, onCloseRequest: this.onCloseRequest, toastType: this.props.toastType, testId: 'connect-to-error-toast', topLeftYPx: FIRST_TOAST_TOP_MARGIN + this.props.errorNumber * OFFSET_BETWEEN_TOASTS }))
            : null;
    };
    return ConnectToErrorToast;
}(React.PureComponent));
exports.ConnectToErrorToast = ConnectToErrorToast;
//# sourceMappingURL=ConnectToErrorHandling.js.map